import React from "react";
import cx from "classnames";
import { Section } from "../../molecules";
import { twMerge } from "../../../utils";
export function Divider(param) {
    var variant = param.variant, background = param.background, className = param.className, enableLines = param.enableLines, disablePadding = param.disablePadding;
    return /*#__PURE__*/ React.createElement(Section, {
        role: "presentation",
        className: className,
        contentClassName: twMerge(disablePadding && "py-0 md:py-0"),
        lines: enableLines ? "dark" : false,
        backgroundColor: background === "colored" ? "offdefault" : "default"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ React.createElement("span", {
        className: cx("block border-y border-fg-inbetween", variant === "small" && "w-[6.25rem]")
    }))));
}

//# sourceMappingURL=Divider.js.map